import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { SystemHealthCheck } from '../../components/admin/SystemHealthCheck';

export function DiagnosticPage() {
  return (
    <AdminLayout
      title="Diagnostic"
      description="Vérifiez l'état de santé du système"
    >
      <SystemHealthCheck />
    </AdminLayout>
  );
}
